/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Requested_Documents_Detail_PlaceholderInputs */

const en_task_requested_documents_detail_placeholder = /** @type {(inputs: Task_Requested_Documents_Detail_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detail (optional)`)
};

const pt_br2_task_requested_documents_detail_placeholder = /** @type {(inputs: Task_Requested_Documents_Detail_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalhe (opcional)`)
};

/**
* | output |
* | --- |
* | "Detail (optional)" |
*
* @param {Task_Requested_Documents_Detail_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_requested_documents_detail_placeholder = /** @type {((inputs?: Task_Requested_Documents_Detail_PlaceholderInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Requested_Documents_Detail_PlaceholderInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_requested_documents_detail_placeholder(inputs)
	return pt_br2_task_requested_documents_detail_placeholder(inputs)
});